// extracted by mini-css-extract-plugin
export var iconContainer = "Icon-module--icon-container--352ab";